<div *ngIf="!isEdited" class="cell-view">
  <div class="inner-view">
    <i class="{{ rowData[fieldName] }}" class="vertical-align-middle text-3xl pr-2"></i>
    <span class="vertical-align-middle">{{ rowData[fieldName] }}</span>
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="IconPickerCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="IconPickerCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup" jmlClickOutside (clickOutside)="abortCellEdit($event)">
    <input
      name="Wert"
      style="width: calc(100% - 30px)"
      pInputText
      [(ngModel)]="rowData[fieldName]"
      [iconPicker]=""
      [ipPosition]="'bottom'"
      [ipIconPack]="['fa']"
      (iconPickerSelect)="onIconPicked($event)"
      (keyup.enter)="isEdited = false; completeCellEdit.emit({ data: rowData, field: fieldName })"
      (keyup.esc)="abortCellEdit($event)"
      jmlAutoFocus
    />
    <button
      pButton
      type="button"
      [id]="fieldName + '§' + rowData['id']"
      icon="pi pi-check"
      (click)="isEdited = false; completeCellEdit.emit({ data: rowData, field: fieldName })"
    ></button>
  </div>
</ng-template>
